export const handlePersonSelected = (person, refetch) => {
	refetch(
		{
			personId: person.value,
		},
		null
	);
	return person.value;
};
